import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import HtmlParser from "react-html-parser";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: "01",
    title: "Robust Core Data<br/> Management",
    description:
      "Our developers specialize in implementing Core Data for efficient data storage and retrieval to make sure smooth performance and reliable data management across all iOS applications, tailored to complex business needs.",
  },
  {
    icon: "02",
    title: "Seamless API<br/> Integration",
    description:
      "Our iPhone app development services include seamless integration of third-party APIs, enhancing app functionality and user experience. We ensure secure, efficient connections to external services using advanced techniques and best practices.",
  },
  {
    icon: "03",
    title: "Scalable Cloud<br/> Integration",
    description:
      "Our iOS development services include scalable cloud integration using iCloud and third-party services like AWS and Firebase, ensuring seamless data synchronization and robust backend support for your app.",
  },
];

function Purposeweb() {
  return (
    <div className="technoloy_sec p-100" style={{ backgroundColor: "#F9F9F9" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={8}
            lg={8}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>Built-to-Perform iOS Software</h2>
            <p>
              Our in-house, expert iOS app developers help businesses BRIDGE
              (Build, Review, Integrate, Deliver, Grow, and Evaluate) modern
              customer engagement needs with purpose-driven iOS application
              development services.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <div className="technology_main web_purpose_text">
              {StackItem.map((item, index) => (
                <div className="technology_item">
                  <div className="svg_icon web_text">{item.icon}</div>
                  <h6>{HtmlParser(item.title)}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Talk to Our Experts
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Purposeweb;
